import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getCardBySlugAndCodeApi } from '../api/cardApi';
import PhotoboothCapture from '../Components/Photobooth/PhotoboothCapture';
import PhotoboothStrip from '../Components/Photobooth/PhotoboothStrip';
import '../CSS/Photobooth.css';

const PhotoboothPage = () => {
  const { slug, uniqueCode } = useParams();
  const [cardData, setCardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);
  const [photos, setPhotos] = useState(null); // null = capture phase, array = strip phase

  /* ── Hide global navbar & footer ─────────────────────────── */
  useEffect(() => {
    const navbar = document.querySelector('.main-navbar');
    const footer = document.querySelector('.main-footer');
    if (navbar) navbar.style.display = 'none';
    if (footer) footer.style.display = 'none';
    return () => {
      if (navbar) navbar.style.display = '';
      if (footer) footer.style.display = '';
    };
  }, []);

  /* ── Fetch card data for theming ─────────────────────────── */
  useEffect(() => {
    if (!slug || !uniqueCode) return;
    const fetch = async () => {
      try {
        const data = await getCardBySlugAndCodeApi(slug, uniqueCode);
        setCardData(data);
      } catch {
        setCardData(null);
        setLoadError(true);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [slug, uniqueCode]);

  const themeColour = cardData?.themeColour || '#45c0c0';
  const isPremium = cardData?.packageType === 'Premium' || cardData?.package === 'Premium';

  if (loading) {
    return (
      <div className="pb-page-loading" style={{ '--pb-theme': themeColour }}>
        <div className="pb-spinner" />
        <p>Memuatkan...</p>
      </div>
    );
  }

  // This check is intentionally on the page, rather than only on a navigation
  // button, so copied or guessed photobooth URLs cannot bypass the package rule.
  if (loadError || !isPremium) {
    return (
      <div className="pb-page" style={{ '--pb-theme': themeColour }}>
        <main className="pb-main">
          <div className="pb-camera-error" style={{ color: '#555', height: 'auto', maxWidth: 420 }}>
            <h1 className="pb-header-title" style={{ color: themeColour }}>Digital Photobooth</h1>
            <p>Digital Photobooth hanya tersedia untuk pakej Premium.</p>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="pb-page" style={{ '--pb-theme': themeColour }}>
      {/* Main content */}
      <main className="pb-main">
        <h1 className="pb-simple-heading">Sejiwa - Digital Photobooth</h1>
        {photos ? (
          <PhotoboothStrip
            photos={photos}
            cardData={cardData}
            onRetake={() => setPhotos(null)}
          />
        ) : (
          <PhotoboothCapture
            cardData={cardData}
            onDone={(capturedPhotos) => setPhotos(capturedPhotos)}
          />
        )}
      </main>
    </div>
  );
};

export default PhotoboothPage;
